module.exports = __webpack_public_path__ + "static/media/dougu_open_banner_en.96d58a89.png";